import BaseService from "./base.service";
const service = new BaseService("/assets")
export default service;